import React from 'react';

function CheckmarkIcon() {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 30 30" enableBackground="new 0 0 30 30">
      <path fill="#017CE0" d="M0.8,16.8l5.1-5.1l4.9,4.9L24.1,3.4l5.1,5.1L11,26.6L0.8,16.8z" />
    </svg>
  );
}

export default CheckmarkIcon;



// WEBPACK FOOTER //
// ./src/components/icons/CheckmarkIcon.js